// extracted by mini-css-extract-plugin
module.exports = {"card":"CtaCard_card__71pu1","icon":"CtaCard_icon__GxG_b","content":"CtaCard_content__kz7vA","title":"CtaCard_title__LfW6m","footer":"CtaCard_footer__xpG68"};